<template>
  <TradeRowParentItem
    v-if="props.tradeItem.has_children"
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :depth="$props.depth"
    :show-percentages="$props.showPercentages"
  />

  <TradeRowItemWithClaim
    v-else
    :trade="$props.trade"
    :claim="$props.claim"
    :trade-item="$props.tradeItem"
    :depth="$props.depth"
    :show-percentages="$props.showPercentages"
  />
</template>

<script setup lang="ts">
import Claim from '@/models/Claim';
import Trade from '@/models/Trade';
import TradeItem from '@/models/TradeItem';
import TradeRowItemWithClaim from './TradeRowItemWithClaim.vue';
import TradeRowParentItem from './TradeRowParentItem.vue';

const props = defineProps<{
  trade: Trade;
  claim: Claim;
  tradeItem: TradeItem;
  depth?: number;
  showPercentages?: boolean;
}>();
</script>

<style scoped></style>
